import p from "./ghl-ui.es1589.js";
import G from "./ghl-ui.es1590.js";
import o from "./ghl-ui.es1586.js";
import f from "./ghl-ui.es1587.js";
import c from "./ghl-ui.es1588.js";
import n from "./ghl-ui.es1591.js";
import { Parser as l } from "./ghl-ui.es1670.js";
var T = /* @__PURE__ */ function(u) {
  f(i, u);
  var s = c(i);
  function i() {
    var a;
    p(this, i);
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return a = s.call.apply(s, [this].concat(t)), n(o(a), "priority", 140), n(o(a), "incompatibleTokens", ["R", "u", "t", "T"]), a;
  }
  return G(i, [{
    key: "parse",
    value: function(e, t, r) {
      switch (t) {
        case "G":
        case "GG":
        case "GGG":
          return r.era(e, {
            width: "abbreviated"
          }) || r.era(e, {
            width: "narrow"
          });
        case "GGGGG":
          return r.era(e, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return r.era(e, {
            width: "wide"
          }) || r.era(e, {
            width: "abbreviated"
          }) || r.era(e, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, t, r) {
      return t.era = r, e.setUTCFullYear(r, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), i;
}(l);
export {
  T as EraParser
};
